<template>
  <Modal
    :size="'tiny'"
    :value="modalDiscountLimit"
    :onClose="handleModalDiscountLimit"
    :close="false"
    :title="'Limite de desconto excedido'"
    ref="modalDiscountLimit"
  >
    <b-row>
      <b-col md="3" lg="12" sm="3">
        <Input
          labelBold
          label="Senha"
          type="password"
          id="discountLimitInput"
          placeholder="Digite a senha do administrador"
          v-model="adminPassword"
          :onEnter="send"
        />
      </b-col>
    </b-row>
    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
      <Button type="success" @click="send()">Confirmar</Button>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Modal } from '@/components';
import { Button, Input } from '@/components/Form';
import { DiscountBasedOnEnum } from '../../enums/DiscountEnum';

export default {
  name: 'ModalDiscountLimit',
  components: {
    Modal,
    Button,
    Input,
  },
  props: {
    discountBasedOn: {
      type: Number,
      default: null,
      validator: (value) =>
        [DiscountBasedOnEnum.ITEM, DiscountBasedOnEnum.DOC].includes(value),
    },
  },
  data() {
    return {
      adminPassword: null,
    };
  },
  computed: {
    ...mapState('client', ['adminPasswordIsValid']),
    ...mapState('fiscal', ['modalDiscountLimit']),
  },
  methods: {
    ...mapActions('client', ['sendAdminPassword', 'cleanAdminPasswordIsValid']),
    ...mapActions('fiscal', ['handleModalDiscountLimit']),
    async send() {
      await this.sendAdminPassword(this.adminPassword);

      this.$emit('authorizedDiscount', this.discountBasedOn);
      this.close();
    },
    close() {
      this.adminPassword = null;
      this.handleModalDiscountLimit();
      this.cleanAdminPasswordIsValid();
    },
  },
};
</script>
